import React from "react";
import ReactDOM from "react-dom";
import { CheckinQuestions } from "../components/Checkin";
import { Notifications } from "../components/Settings";

import { DismissalTimes } from "../components/Dashboard";
import {
  FutureDelegation,
  ChangeDefaultPickup,
  CreateMarkAbsent,
  SelectWhen,
  SelectContact,
  AddContact,
  CancelPickup,
} from "../components/ChildManagement";
import { ViewProfile } from "../components/Settings";
import { ChangePassword } from "../components/Settings";
import { Setting } from "../components/Settings";
import { Contacts } from "../components/Settings";
import { CreateContact } from "../components/Settings";
import { ContactSupport } from "../components/Settings";
//import {store} from '../common/store/index';
import { Provider } from "react-redux";
import { store } from "../common/store/configureStore";

// export const openPopupWindow = (screen, params) => {
//   // console.log("fromScreen", screen);
//   var ModalRootElement = document.getElementById("modal");
//   ReactDOM.unmountComponentAtNode(ModalRootElement)
//   if (screen === "checkin") {

//     ReactDOM.render(<Provider store={store}><CheckinQuestions /></Provider>, ModalRootElement);

//   } else if (screen === "createModifyPickupView") {
//     ReactDOM.render(<Provider store={store}><SelectWhen /></Provider>, ModalRootElement);
//   }else if (screen === "notification") {
//     ReactDOM.render(<Provider store={store}><Notifications /></Provider>, ModalRootElement);
//   }else if(screen === "schoolDetails"){
//     ReactDOM.render( <Provider store={store}> <DismissalTimes /></Provider>,ModalRootElement);
//   }else if(screen === "futureDelegationView"){
//     ReactDOM.render( <Provider store={store}> <FutureDelegation {...params} /></Provider>,ModalRootElement);
//   }else if(screen === "viewProfile"){
//     ReactDOM.render( <Provider store={store}> <ViewProfile /></Provider>,ModalRootElement);
//   }else if(screen === "changePassword"){
//     ReactDOM.render( <Provider store={store}> <ChangePassword /></Provider>,ModalRootElement);
//   }else if(screen === "settingsView"){
//     ReactDOM.render( <Provider store={store}> <Setting /></Provider>,ModalRootElement);
//   }else if(screen === "contactList"){
//     ReactDOM.render( <Provider store={store}> <SelectContact /></Provider>,ModalRootElement);
//   }else if(screen === "addContact"){
//     ReactDOM.render( <Provider store={store}> <AddContact {...params} /></Provider>,ModalRootElement);
//   }else if(screen === "contactSupport"){
//     ReactDOM.render( <Provider store={store}> <ContactSupport /></Provider>,ModalRootElement);
//   }else if(screen === "changeDefualtPickupView"){
//     ReactDOM.render( <Provider store={store}> <ChangeDefaultPickup /></Provider>,ModalRootElement);
//   }else if(screen === "cancelThisPickup"){
//     ReactDOM.render( <Provider store={store}> <CancelPickup /></Provider>,ModalRootElement);
//   }else if(screen === "markAbsentView"){
//     ReactDOM.render( <Provider store={store}> <CreateMarkAbsent /></Provider>,ModalRootElement);
//   }

// };

export const getDismissedInfo = (item) => {
  let dismissalText = "";
  let dismissalTextSubText = "";

  if (item.PM_Name === "After School") {
    dismissalText = item.PM_Name;
    dismissalTextSubText = item.PM_SubName;
  } else if (item.Guardian_First !== "" && item.Guardian_First !== null) {
    dismissalText = `${item.Guardian_First} ${"Picked up"} - ${item.PM_Name}`;
    dismissalTextSubText = item.PM_SubName;
  } else {
    if (item.PM_Name === "Bus") {
      dismissalText = `${"Pickup is by"} - ${item.PM_Name}`;
    } else {
      dismissalText = `${"Pickup was by"} - ${item.PM_Name}`;
    }
    dismissalTextSubText = item.PM_SubName;
  }
  return {
    dismissalText,
    dismissalTextSubText:
      dismissalTextSubText === null ? "" : `-${dismissalTextSubText}`,
  };
};
